import { Link as ReactLink } from 'react-router';
import { Club } from '@repo/types';
import Link from '../../../../common/components/Link/Link';
import { LinkSize, LinkVariant } from '../../../../common/components/Link/contracts';
import { Image, ImageVariant } from '../../../../common/components/Image';

// @ts-ignore
const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

export type StadiumProps = {
  club: Club;
  isMobile: boolean;
};

export function Stadium({ club, isMobile }: StadiumProps) {
  return (
    <div className="team-overview-general-info__wrapper">
      <h3 className="team-overview__tab-title">Home Venue</h3>
      <div className="team-overview-stadium__container">
        <div className="team-overview-stadium__general-info-container">
          <div className="team-overview-stadium__left-column">
            {club.stadiumImage && (
              <div className="team-overview-stadium__image-container">
                <Image
                  className="team-overview-stadium__image"
                  variant={ImageVariant.Hero}
                  src={club.stadiumImage}
                  alt={club.stadiumName ?? club.fullName}
                  fill
                />
              </div>
            )}
            <ul className="team-overview-list">
              {club.stadiumName && (
                <li className="team-overview-list__item">
                  <span className="team-overview-list__type">Venue</span>
                  <span className="team-overview-list__value">{club.stadiumName}</span>
                </li>
              )}
              {club.stadiumSeatedCapacity && (
                <li className="team-overview-list__item">
                  <span className="team-overview-list__type">Seated capacity</span>
                  <span className="team-overview-list__value">{club.stadiumSeatedCapacity}</span>
                </li>
              )}
              {club.stadiumStandingCapacity && (
                <li className="team-overview-list__item">
                  <span className="team-overview-list__type">Total capacity</span>
                  <span className="team-overview-list__value">{club.stadiumStandingCapacity}</span>
                </li>
              )}
              {club.stadiumAccessibleSeatingCapacity && (
                <li className="team-overview-list__item">
                  <span className="team-overview-list__type">Accessible seating capacity</span>
                  <span className="team-overview-list__value">{club.stadiumAccessibleSeatingCapacity}</span>
                </li>
              )}
              {club.pitchSurface && (
                <li className="team-overview-list__item">
                  <span className="team-overview-list__type">Surface</span>
                  <span className="team-overview-list__value">{club.pitchSurface}</span>
                </li>
              )}
              {club.pitchSize && (
                <li className="team-overview-list__item">
                  <span className="team-overview-list__type">Pitch size</span>
                  <span className="team-overview-list__value">{club.pitchSize}</span>
                </li>
              )}
              {club.address && (
                <li className="team-overview-list__item">
                  <span className="team-overview-list__type">Home</span>
                  <span className="team-overview-list__value">{club.address.formattedAddress}</span>
                </li>
              )}
              {club.clubTicketWebsite && (
                <li className="team-overview-list__item">
                  <span className="team-overview-list__type">Tickets</span>
                  <ReactLink to={club.clubTicketWebsite}>{club.clubTicketWebsite}</ReactLink>
                </li>
              )}
            </ul>
          </div>
          <div className={'team-overview-stadium__right-column'}>
            {GOOGLE_MAPS_API_KEY && !!club?.address?.lat && !!club?.address?.lng && (
              <iframe
                width="100%"
                height={isMobile ? 200 : 320}
                style={{
                  border: 0,
                }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_API_KEY}&zoom=17&q=${club.address.lat},${club.address.lng}`}
              ></iframe>
            )}
            {club.clubStadiumDirections && (
              <li className="team-overview-list__item">
                <span className="team-overview-list__type">directions</span>
                <div
                  className="team-overview-list__value"
                  dangerouslySetInnerHTML={{ __html: club.clubStadiumDirections }}
                />
              </li>
            )}
            <div />
            {(club.clubTicketWebsite || club.clubTicketPrices) && (
              <div className="team-overview-stadium__tickets">
                <h2>Tickets</h2>
                <div className="team-overview-stadium-info__tickets-container">
                  {club.clubTicketPrices && (
                    <div
                      className="team-overview-stadium__rich-text"
                      dangerouslySetInnerHTML={{ __html: club.clubTicketPrices }}
                    />
                  )}

                  <div className="team-overview-stadium__tickets-buy-btn">
                    {club.clubTicketWebsite && (
                      <Link
                        url={club.clubTicketWebsite}
                        label={'Buy Here'}
                        openInNewTab={false}
                        variant={LinkVariant.Outlined}
                        size={LinkSize.lg}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
